import * as React from "react";
import { useState } from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import { CiMenuKebab } from "react-icons/ci";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { MdOutlineStickyNote2, MdOutlineHistory } from "react-icons/md";
import { BsTrash } from "react-icons/bs";
import { MdSettings } from "react-icons/md";
import { PiUsersThree } from "react-icons/pi";
import LoginUserModel from "../../../LoginUser/LoginUser";
import { useTranslation } from "react-i18next";

export default function CustomMenu({
  row,
  setInvoicesHistoryModal,
  setHistoryModal,
  setConfirmDelete,
  setAdminControlsModal,
  setOpenHelperUsersModal,
}) {
  const { t } = useTranslation("admin");
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const [loginModal, setLoginModal] = useState(false);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <LoginUserModel open={loginModal} setOpen={setLoginModal} />
      <div className="table_action__wrap">
        <div
          className={`table_action__btn ${
            [false, "false", "0", null, undefined].includes(row.account_status)
              ? "table_action__btn__disabled"
              : ""
          }`}
          onClick={() => {
            setLoginModal(row);
          }}
        >
          {t("users.login")}
        </div>
        <div className="table_action__btn" onClick={handleClick}>
          <CiMenuKebab size={10} style={{ marginRight: "2px" }} />
          {t("users.more")}
        </div>
        <Menu
          id={`basic-menu-${row.id}`} // Unique ID for each row
          anchorEl={anchorEl}
          open={open}
          size="small"
          onClose={handleClose}
          MenuListProps={{
            "aria-labelledby": `basic-button-${row.id}`, // Unique ID for each row
            "box-shadow": "none",
          }}
        >
          <MenuItem
            className="boltTable__action_more_btn_label"
            onClick={() => {
              setInvoicesHistoryModal(row);
              handleClose();
            }}
          >
            <ListItemIcon>
              <MdOutlineStickyNote2 size={15} />
            </ListItemIcon>
            <ListItemText>{t("users.invoices")}</ListItemText>
          </MenuItem>
          <MenuItem
            className="boltTable__action_more_btn_label"
            onClick={() => {
              setHistoryModal(row);
              handleClose();
            }}
          >
            <ListItemIcon>
              <MdOutlineHistory size={15} />
            </ListItemIcon>
            <ListItemText>{t("users.transactions")}</ListItemText>
          </MenuItem>
          {setOpenHelperUsersModal && (
            <MenuItem
              className="boltTable__action_more_btn_label"
              onClick={() => {
                setOpenHelperUsersModal({
                  user_id: row.id,
                  name: row.business_name || row.username,
                  code: row.username,
                });
                handleClose();
              }}
            >
              <ListItemIcon>
                <PiUsersThree size={15} />
              </ListItemIcon>
              <ListItemText>{t("users.helperUsers")}</ListItemText>
            </MenuItem>
          )}
          <MenuItem
            className="boltTable__action_more_btn_label"
            onClick={() => {
              // Open AdminControls modal with shipper data
              const shipperData = {
                username: row.username,
                businessName: row.business_name,
                ...row,
              };
              setAdminControlsModal(shipperData);
              handleClose();
            }}
          >
            <ListItemIcon>
              <MdSettings size={15} />
            </ListItemIcon>
            <ListItemText>{t("users.adminControls")}</ListItemText>
          </MenuItem>
          <MenuItem
            className="boltTable__action_more_btn_label"
            onClick={() => {
              setConfirmDelete(row);
              handleClose();
            }}
          >
            <ListItemIcon>
              <BsTrash size={15} />
            </ListItemIcon>
            <ListItemText>{t("common:actions.delete")}</ListItemText>
          </MenuItem>
        </Menu>
      </div>
    </>
  );
}
